import React, { Component } from "react";
import { Route } from "react-router-dom";
import Master from "./Master";
import Login from "./components/Login/Login";
import Register from "./components/Register/Register";
import Password from "./components/Password/Password";

class Hoc extends Component {
  state = {};
  render() {
    if (process.env.NODE_ENV !== "development") {
      console.log = () => {};
      console.warn = () => {};
      console.error = () => {};
    }
    const validEmail = localStorage.getItem("email");
    if (validEmail) {
      return <Master />;
    } else {
      return (
        <div>
          <Route path="/" exact component={Login} />
          <Route path="/register" exact component={Register} />
          <Route path="/password" exact component={Password} />
        </div>
      );
    }
  }
}

export default Hoc;



// WEBPACK FOOTER //
// ./src/Hoc.js